import { Injectable } from '@angular/core';
import { ApiProvider } from '../api/api';


@Injectable()

export class PurchaseService {

  user: any;

  constructor(
    public api: ApiProvider,
  ) {
    //
  }

  async getListPaymentLink(qtd: number = 1) {
    let message: any;
    return this.api.get('v3/purchase/customer/payments/' + qtd).then(
    // return this.api.get('mobile/payment/list').then(
      (res: any) => {
        return res;
      }
    ).catch(
      (err: any) => {
        if (err.status === 422 || err.status === 404) {
          message = err.error.err;
        } else {
          message = 'Algo não funcionou bem. Tente novamente.';
        }
        throw new Error(message);
      }
    );
  }

  async getPaymentLink(plan_id: any) {
    let message: any;
    // return this.api.post('mobile/payment/premium', { plan_id }).then(
    return this.api.post('v3/purchase/customer/payment/premium', { plan_id }).then(
      (res: any) => {
        return res;
      }
    ).catch(
      (err: any) => {
        if (err.status === 422 || err.status === 404) {
          message = err.error.err;
        } else {
          message = 'Algo não funcionou bem. Tente novamente.';
        }
        throw new Error(message);
      }
    );
  }


  async pagarme() {
    return this.api.get('v3/purchase/customer/pagarme').then(
      (res: any) => {
        return res;
      },
      (err: any) => {
        throw new Error(err.error.err);
      }
    );
  }  

  async updatePagarme(data: any) {
    return this.api.post('v3/purchase/customer/pagarme', data).then(
      (res: any) => {
        return res;
      },
      (err: any) => {
        throw new Error(err.error.err);
      }
    );
  }


  async getSubscription() {
    return this.api.get('v3/purchase/customer/subscription').then(
      (res: any) => {
        return res;
      },
      (err: any) => {
        throw new Error(err.error.err);
      }
    );
  }  

  async createSubscription(data: any) {
    return this.api.post('v3/purchase/customer/subscription', data).then(
      (res: any) => {
        return res;
      },
      (err: any) => {
        throw new Error(err.error.err);
      }
    );
  }

  async cancelSubscription() {
    return this.api.delete('v3/purchase/customer/subscription').then(
      (res: any) => {
        return res;
      },
      (err: any) => {
        throw new Error(err.error.err);
      }
    );
  }

  async getPagarme() {
    return this.api.get('v3/purchase/customer/pagarme').then(
      (res: any) => {
        return res;
      },
      (err: any) => {
        throw new Error(err.error.err);
      }
    );
  }

  async setPagarme(data: any) {
    return this.api.post('v3/purchase/customer/pagarme', data).then(
      (res: any) => {
        return res;
      },
      (err: any) => {
        throw new Error(err.error.err);
      }
    );
  }



}
